/**
 * HubSpot match runs: read and started through the Go API (`eduleadV4.matches`), their export made
 * through `eduleadV4.exports`.
 */

/** Statuses where the run is still working, so the page should watch for progress. */
export const ACTIVE_MATCH_RUN_STATUSES = ['CREATED', 'FETCHING', 'MATCHING'];

export function isMatchRunActive(status?: string): boolean {
  return !!status && ACTIVE_MATCH_RUN_STATUSES.includes(status);
}

